'use strict';

var ROMNonStopFilterFactory = function ROMNonStopFilterFactory(DataFilter) {
  function ROMNonStopFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode'], 'filter-component', 2);
  }
  ROMNonStopFilter.prototype = Object.create(DataFilter.prototype);
  ROMNonStopFilter.prototype.filter = function (data, range) {
    range = range[0];
    return range.isNonStop.length === 0 ? data : DataFilter.prototype.filter(data, range.isNonStop, 'isNonStop');
  };
  return ROMNonStopFilter;
};
ROMNonStopFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMNonStopFilterFactory;